import { type Tag } from '@hungryroot/rest';

import { tags } from '../tags';

const MEAT_BFL_L1_TAG_IDS: number[] = [
  tags.BeefBflL1,
  tags.BisonBflL1,
  tags.LambBflL1,
  tags.PorkBflL1,
  tags.PoultryBflL1,
];

/**
 * A product is considered "meat" when it carries one of the "BFL L1 -
 * {Beef,Bison,Lamb,Pork,Poultry}" tags. We key off these tags rather than
 * `primary_category_name`, because the catalog groups meat and seafood into a
 * single "Meat + Seafood" category — so a salmon or shrimp product shares
 * that category name and must NOT be treated as meat.
 */
export function isMeatProduct(
  productTags: Pick<Tag, 'id'>[] | undefined | null
): boolean {
  return (
    productTags?.some((tag) => MEAT_BFL_L1_TAG_IDS.includes(tag.id)) ?? false
  );
}
